import {
  styled,
  FormControl,
  Box,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { pxToRem } from '~/theme/typography';

export const dropdown = {
  FormControl: styled(FormControl)(({ theme }) => ({
    margin: '8px 16px 0px 0px',
    [theme.breakpoints.down('desktop')]: {
      margin: '4px 0px',
    },
  })),
  Container: styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    [theme.breakpoints.down('desktop')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '0px 8px',
    },
  })),
  Label: styled(InputLabel)(({ theme }) => ({
    fontSize: pxToRem(18),
    color: theme.palette.text.primary,
    '&.MuiInputLabel-shrink': {
      color: '#8D8988',
    },
  })),
  Select: styled(Select)(({ theme }) => ({
    width: '204px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #C3AF00',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #8D8988',
    },
    [theme.breakpoints.down('desktop')]: {
      width: '100%',
    },
  })),
  Item: styled(MenuItem)(() => ({
    height: '54px',
    '&:hover': {
      backgroundColor: '#FFDED9',
    },
    '&.Mui-selected': {
      backgroundColor: '#FFDED9',
      '&:hover': {
        backgroundColor: '#FFDED9',
      },
    },
  })),
};
